import { DoqFaceSvgProps } from '../types';
import { GoneDoq } from './GoneDoq';

const DependencyMapGone = (props: DoqFaceSvgProps) => (
  <GoneDoq {...props}>
    <path
      d="M143.8 140.6C147.776 140.6 151 137.376 151 133.4C151 129.424 147.776 126.2 143.8 126.2C139.823 126.2 136.6 129.424 136.6 133.4C136.6 137.376 139.823 140.6 143.8 140.6Z"
      fill="#2E0057"
    />
    <path
      d="M176.2 140.6C180.176 140.6 183.4 137.376 183.4 133.4C183.4 129.424 180.176 126.2 176.2 126.2C172.223 126.2 169 129.424 169 133.4C169 137.376 172.223 140.6 176.2 140.6Z"
      fill="#2E0057"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M160 162.2C154.67 162.2 150.016 159.304 147.526 155L151.95 155C153.927 157.21 156.801 158.6 160 158.6C163.198 158.6 166.072 157.21 168.05 155L172.473 155C169.983 159.304 165.33 162.2 160 162.2Z"
      fill="#2E0057"
    />
    <path
      opacity="0.5"
      d="M95.2002 191.225C95.2002 187.249 98.4237 184.025 102.4 184.025H217.6C221.577 184.025 224.8 187.249 224.8 191.225V241.625C224.8 245.601 221.577 248.825 217.6 248.825H102.4C98.4237 248.825 95.2002 245.601 95.2002 241.625V191.225Z"
      fill="#4C008F"
    />
    <path
      d="M109.744 205.4C109.744 201.424 112.968 198.2 116.944 198.2H203.538C207.514 198.2 210.738 201.424 210.738 205.4C210.738 209.377 207.514 212.6 203.538 212.6H116.944C112.968 212.6 109.744 209.377 109.744 205.4Z"
      fill="white"
    />
    <path
      d="M116.944 219.77C112.968 219.77 109.744 222.994 109.744 226.97C109.744 230.947 112.968 234.17 116.944 234.17H131.425C135.402 234.17 138.625 230.947 138.625 226.97C138.625 222.994 135.402 219.77 131.425 219.77H116.944Z"
      fill="white"
    />
    <path
      d="M181.49 227.164C181.49 223.188 184.713 219.964 188.69 219.964H203.171C207.148 219.964 210.371 223.188 210.371 227.164C210.371 231.141 207.148 234.364 203.171 234.364H188.69C184.713 234.364 181.49 231.141 181.49 227.164Z"
      fill="white"
    />
    <path
      d="M153 219.964C149.024 219.964 145.8 223.188 145.8 227.164C145.8 231.141 149.024 234.364 153 234.364H167.481C171.458 234.364 174.681 231.141 174.681 227.164C174.681 223.188 171.458 219.964 167.481 219.964H153Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M101.275 198.255C101.275 193.781 104.902 190.155 109.375 190.155H210.625C215.099 190.155 218.725 193.781 218.725 198.255V234.783C218.725 239.257 215.099 242.883 210.625 242.883H109.375C104.902 242.883 101.275 239.257 101.275 234.783V198.255ZM109.375 191.955C105.896 191.955 103.075 194.775 103.075 198.255V234.783C103.075 238.263 105.896 241.083 109.375 241.083H210.625C214.105 241.083 216.925 238.263 216.925 234.783V198.255C216.925 194.775 214.105 191.955 210.625 191.955H109.375Z"
      fill="white"
    />
  </GoneDoq>
);

export { DependencyMapGone };
